<template>
  <div class="container">
    <van-cell-group>
      <van-field
        v-model="title"
        rows="1"
        autosize
        label="主题"
        type="textarea"
        maxlength="15"
        show-word-limit
      />
      <van-field
        v-model="content"
        rows="1"
        autosize
        label="活动内容"
        type="textarea"
      />
      <van-field
        v-model="starttime"
        rows="1"
        autosize
        readonly
        clickable
        label="开始时间"
        type="textarea"
        @click="showPicker = true"
      />
      <!-- :min-date="minDate" -->
      <van-popup v-model="showPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          show-toolbar
          @cancel="showPicker = false"
          @confirm="onConfirm"
          type="datetime"
          title="选择完整时间"
        />
      </van-popup>
      <van-field
        v-model="endtime"
        rows="1"
        autosize
        readonly
        clickable
        label="结束时间"
        type="textarea"
        @click="showendPicker = true"
      />
      <van-popup v-model="showendPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          show-toolbar
          @cancel="showendPicker = false"
          @confirm="onendConfirm"
          type="datetime"
          title="选择完整时间"
        />
      </van-popup>
      <van-field v-model="total_count" label="上限人数" />
      <van-field
        v-model="address"
        rows="1"
        autosize
        label="活动地点"
        type="textarea"
      />
      <!-- <van-cell center title="是否需要定位">
        <template #right-icon>
          <van-switch v-model="checked" />
        </template>
      </van-cell> -->
    </van-cell-group>
    <div style="position: relative" v-show="map">
      <van-search
        v-model="search"
        placeholder="搜索地点"
        v-show="checked"
        show-action
        @search="onSearch"
        @cancel="onCancel"
        @input="onInput"
        id="tipinput"
      />
      <!-- 搜索结果列表 -->
      <div class="search-results" v-show="showResults">
        <van-cell
          v-for="(item, index) in tips"
          :key="index"
          :title="item.name"
          :label="item.district + item.address"
          @click="selectLocation(item)"
        />
      </div>
    </div>
    <div id="allmap" v-show="checked">
      <!-- 须修改 -->
      <!-- <baidu-map
        class="bmView"
        :scroll-wheel-zoom="true"
        :center="location"
        :zoom="zoom"
        @click="getLocationPoint"
        @ready="handler"
        ak="xwYMjzVQrbLBGNkYbYN9ifSk3s7io1TE"
      >
        <bm-auto-complete v-model="search">
          <form action="/">
            <van-search v-model="search" placeholder="搜索地点" />
          </form>
        </bm-auto-complete>
        <bm-view style="width: 100%; height: 100%; flex: 1"></bm-view>
        <bm-local-search
          :keyword="search"
          :auto-viewport="true"
          style="display: none"
        ></bm-local-search>
        <bm-marker
          :position="{ lng: lng, lat: lat }"
          :icon="{
            url: 'static/img/02.png',
            opts: { imageSize: { width: 30, height: 30 } },
            size: { width: 30, height: 30 },
          }"
        ></bm-marker>
      </baidu-map> -->
    </div>
    <van-cell-group>
      <van-field v-model="lng" v-show="checked" readonly label="经度" />
      <van-field v-model="lat" v-show="checked" readonly label="纬度" />
      <van-cell center title="范围">
        <template #default>
          <van-radio-group v-model="range" direction="horizontal">
            <van-radio name="1">公开</van-radio>
            <van-radio name="2">不公开</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <van-field v-model="contact_name" label="联系人" />
      <van-field v-model="contact_mobile" label="联系人电话" />
      <van-field
        v-model="orgs"
        rows="1"
        autosize
        readonly
        label="创建组织"
        type="textarea"
        @click="orgsshowPicker = true"
      />
      <van-popup v-model="orgsshowPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="orgs_columns"
          value-key="name"
          @cancel="orgsshowPicker = false"
          @confirm="orgsonConfirm"
        />
      </van-popup>
      <van-cell center title="活动封面（选填）">
        <template #default>
          <van-uploader
            style="padding: 10px"
            :after-read="afterRead"
            v-model="fileList"
            :max-count="1"
          />
        </template>
      </van-cell>
      <p class="tips">注：如不上传封面，将显示默认封面</p>
    </van-cell-group>
    <div class="bt" @click="submit">提交创建活动申请</div>
  </div>
</template>
<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  name: "addevent",
  data() {
    return {
      title: "",
      content: "",
      img: "",
      tag: "",
      starttime: "",
      endtime: "",
      total_count: "",
      address: "",
      needgis: 0,
      lng: "",
      lat: "",
      range: "1",
      contact_name: "",
      contact_mobile: "",
      currentDate: new Date(),
      minDate: new Date(),
      showPicker: false,
      showendPicker: false,
      checked: true,
      org_id: "",
      fileList: [],
      search: "",
      searchresult: "",
      location: {
        lng: 120.276,
        lat: 31.883,
      },
      location_center: [120.276, 31.883],
      zoom: 12,
      orgs: "",
      orgs_columns: [],
      orgsshowPicker: false,
      appId: "2312",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
      defaultorg: "",
      uploadimage: "",
      tips: [], // 搜索提示列表
      showResults: false, // 是否显示搜索结果
      map: null,
      placeSearch: null, // 地点搜索实例
      autoComplete: null, // 输入提示实例
      marker: null, // 标记点
    };
  },
  watch: {
    checked(val) {
      console.log(val);
      if (val) {
        this.needgis = 1;
      } else {
        this.needgis = 0;
      }
    },
  },
  beforeDestroy() {
    // 组件销毁时移除地图事件
    if (this.map) {
      this.map.off("click", this.handleMapClick);
      this.map.destroy();
    }
  },
  created() {
    this.initAMap();
    var that = this;
    //app
    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        that.queryUserInfoAll();
      },
    });
    Date.prototype.format = function (fmt) {
      var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        S: this.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (this.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    };
    this.$axios({
      method: "post",
      url: "/api/task/get_my_admin_orgs",
    }).then((res) => {
      console.log(res.data);
      this.orgs_columns = res.data.data;
      this.orgs = this.orgs_columns[0].name;
      this.org_id = this.orgs_columns[0].id;
      this.$axios({
        method: "post",
        url: "/api/home/index",
      }).then((res) => {
        console.log(res.data);
        this.defaultorg = res.data.data.member.default_orgid;
        for (let i in this.orgs_columns) {
          if (this.orgs_columns[i].id == this.defaultorg) {
            this.orgs = this.orgs_columns[i].name;
            this.org_id = this.orgs_columns[i].id;
          }
        }
      });
    });
  },
  methods: {
    /* 转换百度坐标为高德坐标 */
    transBaiduToAMap(point) {
      AMap.convertFrom(point, "baidu", function (status, result) {
        //status：complete 表示查询成功，no_data 为查询无结果，error 代表查询错误
        //查询成功时，result.locations 即为转换后的高德坐标系
        if (status === "complete" && result.info === "ok") {
          var lnglats = result.locations; //转换后的高德坐标 Array.<LngLat>
          console.log(lnglats);
          return lnglats;
        }
      });
    },
    /* 添加高德地图 */
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "0be51f53e8048ee024013bf11171f342",
      };
      AMapLoader.load({
        key: "c0f480cad7e81b5ff672439bac0174d7", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
          "AMap.ToolBar",
          "AMap.AutoComplete",
          "AMap.PlaceSearch",
          "AMap.Geocoder",
        ], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("allmap", {
            // 设置地图容器id
            zoom: 12, // 初始化地图级别
            //center: this.transBaiduToAMap(this.location_center), // 初始化地图中心点位置
            center: this.location_center, // 初始化地图中心点位置
            viewMode: "2D", //设置地图模式
          });
          this.map.addControl(new AMap.ToolBar({ position: "RT" }));
          // 初始化输入提示
          this.autoComplete = new AMap.AutoComplete({
            city: "320281", // 限制城市范围，'全国'表示不限
            citylimit: true,
          });
          // 初始化地点搜索
          this.placeSearch = new AMap.PlaceSearch({
            map: this.map,
            city: "320281",
            citylimit: true,
          });

          // 创建标记点
          this.marker = new AMap.Marker({
            map: this.map,
          });
          this.map.on("click", this.handleMapClick);
          //console.log(this.autoComplete);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 地图点击事件处理
    handleMapClick(e) {
      // 获取点击位置的经纬度
      const lnglat = e.lnglat;

      this.lng = lnglat.lng;
      this.lat = lnglat.lat;
      // 更新标记点位置
      this.marker.setPosition(lnglat);
      // 可选: 将地图中心点移动到点击位置
      this.map.setCenter(lnglat);

      // 可选: 进行逆地理编码获取地址信息
      this.getAddress(lnglat);
    },
    // 逆地理编码获取地址信息
    getAddress(lnglat) {
      const geocoder = new AMap.Geocoder({
        radius: 1000, // 范围，单位：米
        extensions: "all", // 返回详细信息
      });

      geocoder.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          const address = result.regeocode.formattedAddress;
          console.log("详细地址:", address);

          // 可以在这里处理地址信息，如显示在界面上
          this.marker.setTitle(address);
          this.marker.setLabel({
            content: address,
            offset: new AMap.Pixel(0, 0),
            direction: "top",
          });
        }
      });
    },
    // 输入时获取提示
    onInput() {
      //console.log(this.search);
      if (!this.search.trim()) {
        this.tips = [];
        this.showResults = false;
        return;
      }
      //console.log(this.map);
      this.autoComplete.search(this.search, (status, result) => {
        //console.log(result);
        if (status === "complete" && result.tips) {
          this.tips = result.tips;
          this.showResults = true;
        } else {
          this.tips = [];
          this.showResults = false;
        }
      });
    },
    // 选择地点
    selectLocation(item) {
      this.search = item.name;
      this.showResults = false;

      // 根据名称搜索地点
      this.placeSearch.search(item.name, (status, result) => {
        if (
          status === "complete" &&
          result.poiList &&
          result.poiList.pois.length
        ) {
          const poi = result.poiList.pois[0];

          this.lng = poi.location.lng;
          this.lat = poi.location.lat;
          // 移动地图中心点到选中位置
          this.map.setCenter(poi.location);

          // 更新标记点位置
          this.marker.setPosition(poi.location);

          // 可以在这里获取更多地点详情
          this.getLocationDetail(poi.id);
        }
      });
    },
    // 获取地点详情
    getLocationDetail(poiId) {
      this.placeSearch.getDetails(poiId, (status, result) => {
        //console.log(result);
        if (status === "complete" && result.poiList.pois.length > 0) {
          //console.log("地点详情:", result.poiInfo);
          // 可以在这里处理地点详情信息
          this.marker.setTitle(result.poiList.pois[0].name);
          this.marker.setLabel({
            content: result.poiList.pois[0].name,
            offset: new AMap.Pixel(0, 0),
            direction: "top",
          });
        }
      });
    },

    // 搜索按钮点击
    onSearch() {
      if (!this.search.trim()) return;

      // 根据名称搜索地点
      this.placeSearch.search(this.search, (status, result) => {
        if (
          status === "complete" &&
          result.poiList &&
          result.poiList.pois.length
        ) {
          this.tips = [];
          this.showResults = false;
          const poi = result.poiList.pois[0];

          this.lng = poi.location.lng;
          this.lat = poi.location.lat;
          // 移动地图中心点到选中位置
          this.map.setCenter(poi.location);

          // 更新标记点位置
          this.marker.setPosition(poi.location);

          // 可以在这里获取更多地点详情
          this.getLocationDetail(poi.id);
        }
      });
    },
    // 取消搜索
    onCancel() {
      this.search = "";
      this.tips = [];
      this.showResults = false;
    },
    bMapToQQMap(lng, lat) {
      if (lng == null || lng == "" || lat == null || lat == "")
        return [lng, lat];
      var x_pi = 3.14159265358979324;
      var x = parseFloat(lng) - 0.0065;
      var y = parseFloat(lat) - 0.006;
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      var lng = (z * Math.cos(theta)).toFixed(7);
      var lat = (z * Math.sin(theta)).toFixed(7);
      return [lng, lat];
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryUserInfoAll: function () {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.queryUserInfoAll({
          sign: sign,
          params: {
            type: "2",
          },
          success: function (ret) {
            console.log("获取用户信息成功：" + ret);
            var data = JSON.parse(ret);
            if (data.uid) {
              sessionStorage.setItem("uid", data.uid);
            } else {
              alert("请登录app");
            }
            that.contact_mobile = data.mobile;
            that.contact_name = data.authenticationName;
            console.log(ret);
            console.log(JSON.parse(ret));
          },
          error: function (error) {
            console.log("获取用户信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    //app相关结束
    handler({ BMap, map }) {
      window.map = map;
    },
    getLocationPoint(e) {
      this.lng = e.point.lng;
      this.lat = e.point.lat;
    },
    orgsonConfirm(value) {
      console.log(value);
      this.org_id = value.id;
      this.orgs = value.name;
      this.orgsshowPicker = false;
    },
    onConfirm(value) {
      //console.log(value);
      this.starttime = value.format("yyyy-MM-dd hh:mm:00");
      this.showPicker = false;
    },
    onendConfirm(value) {
      this.endtime = value.format("yyyy-MM-dd hh:mm:00");
      this.showendPicker = false;
    },
    afterRead(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/common/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          console.log(res.data);
          console.log(this.fileList);
          this.fileList[this.fileList.length - 1].url = res.data.data.url;
        });
    },
    submit() {
      console.log(this.bMapToQQMap(this.lng, this.lat));
      console.log(
        this.title,
        this.content,
        this.starttime,
        this.endtime,
        this.total_count,
        this.address,
        this.checked,
        this.lng,
        this.lat,
        this.range,
        this.contact_name,
        this.contact_mobile
      );
      if (!this.title) {
        this.$toast("请填写主题");
        return;
      }
      if (!this.content) {
        this.$toast("请填写活动内容");
        return;
      }
      if (!this.starttime) {
        this.$toast("请选择开始时间");
        return;
      }
      if (!this.endtime) {
        this.$toast("请选择结束时间");
        return;
      }
      /* if(!this.total_count){
        this.$toast('请输入上限人数');
        return;
      } */
      if (!this.address) {
        this.$toast("请填写活动地点");
        return;
      }
      /* if (this.checked && (!this.lng || !this.lat)) {
        this.$toast("请在地图上标点");
        return;
      } */
      if (!this.contact_name) {
        this.$toast("请填写联系人");
        return;
      }
      if (!this.contact_mobile) {
        this.$toast("请填写联系人电话");
        return;
      }
      if (!this.orgs) {
        this.$toast("请选择组织");
        return;
      }
      if (this.fileList.length == 0) {
        this.uploadimage = "static/img/default.png";
      } else {
        this.uploadimage = this.fileList[0].url;
      }
      this.$axios({
        method: "post",
        url: "/api/task/create_task",
        data: this.qs.stringify({
          org_id: this.org_id,
          title: this.title,
          content: this.content,
          img: this.uploadimage,
          starttime: this.starttime,
          endtime: this.endtime,
          total_count: this.total_count,
          address: this.address,
          needgis: this.needgis,
          // lng: this.bMapToQQMap(this.lng, this.lat)[0],
          // lat: this.bMapToQQMap(this.lng, this.lat)[1],
          lng: this.lng,
          lat: this.lat,
          range: this.range,
          contact_name: this.contact_name,
          contact_mobile: this.contact_mobile,
        }),
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("创建成功");
          this.$router.push("/createevent");
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
#allmap {
  width: 100%;
  height: 80vw;
}
.bmView {
  width: 100%;
  height: 80vw;
}
.bt {
  width: 80%;
  line-height: 40px;
  height: 40px;
  text-align: center;
  color: white;
  background: #cab586;
  border-radius: 5px;
  margin: 20px auto;
}
.tips {
  color: #a1a1a1;
  font-size: 12px;
  padding: 15px;
}
.search-results {
  position: absolute;
  top: 54px;
  left: 0;
  right: 0;
  z-index: 999;
  background: white;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/addevent.vue